<template>
    <div class="l-body">
        <LBackgruond>
            <template v-slot:mainName>
                战绩点评
            </template>
            <template v-slot:mainContent>
                <div class="l-detail-record-body">
                    <div class="l-logo">
                        <img :src="logoUrl" />
                    </div>
                    <div class="l-text">
                        <div class="header">
                            <!-- <div class="tiem"> -->
                            <!-- <span>{{ detailData.commentName }}</span> -->
                            <!-- <span>{{ detailData.startTime.slice(0, 10) }}至{{ detailData.endTime.slice(0, 10)}}</span> -->
                            <!-- </div> -->
                            <div class="level">
                                {{ detailData.commentInfo.stageName }}
                            </div>
                        </div>
                        <div v-if="detailData.audioUrl" class="content-box">
                            <div class="content">
                                <div class="title notWell">
                                    <img src="./../images/notWell.png" />
                                    <span>语音点评</span>
                                </div>
                                <div class="text">
                                    <audio class="audio" controls controlsList="nodownload" :src="detailData.audioUrl">
                                        您的浏览器不支持 audio 元素。
                                    </audio>
                                </div>
                            </div>
                        </div>
                        <div v-else class="content-box">
                            <div class="content ">
                                <div class="title notWell">
                                    <img src="./../images/notWell.png" />
                                    <span>本次战绩点评</span>

                                </div>
                                <div class="text">
                                    {{ detailData.commentInfo.notWell }}
                                </div>
                            </div>
                            <div v-if="detailData.commentInfo.plan" class="content plan">
                                <div class="title">
                                    <img src="./../images/plan.png" />
                                    <span>
                                        后续提高方案
                                    </span>
                                </div>
                                <div class="text">{{ detailData.commentInfo.plan }}</div>
                            </div>
                            <div v-if="detailData.commentInfo.well" class="content ">
                                <div class="title well">
                                    <img src="./../images/well.png" />
                                    <span>
                                        本次进步点
                                    </span>
                                </div>
                                <div class="text">{{ detailData.commentInfo.well }}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>
        </LBackgruond>
    </div>
</template>
<script>
import LBackgruond from "./../components/l-background"
export default {
    name: 'recordDetail',
    components: {
        LBackgruond
    },
    data () {
        return {
            detailData: {},
            detailType: [
                {
                    name: '优秀',
                    url: require('./../images/level-excellent.png')
                },
                {
                    name: '良好',
                    url: require('./../images/level-well.png')
                },
                {
                    name: '中等',
                    url: require('./../images/level-medium.png')
                },
                {
                    name: '及格',
                    url: require('./../images/level-pass.png')
                },
                {
                    name: '未及格',
                    url: require('./../images/level-fail.png')
                }
            ],
            logoUrl: require('./../images/level-excellent.png')
        }
    },
    mounted () {
        this.detailData = JSON.parse(sessionStorage.getItem('recordData'))
        this.handleSetImg()
    },
    methods: {
        handleSetImg () {
            if (this.detailData.commentInfo.score) {
                this.detailType.forEach(element => {
                    if (element.name === this.detailData.commentInfo.score) {
                        this.logoUrl = element.url
                    }

                });
            }
        }
    }

}
</script>
<style lang="stylus" scoped>
@import './css/detail.styl';
</style>